import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import BraitenbergVehiclesPage from './routes/projects/braitenberg-vehicles'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root')
createRoot(root).render(<StrictMode><BraitenbergVehiclesPage /></StrictMode>)
